module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms/src/datagrid/datagrid-table/datagrid-table.component.html
// module id = ./libs/atenea-cms/src/datagrid/datagrid-table/datagrid-table.component.html
// module chunks = main